module.exports = __webpack_public_path__ + "static/chat-laptop-1b563bd52e87db4c025bb59b82b4177b.jpg";